import { NbToastrConfig } from './toastr-config';

export class NbToast {
  title: string;
  message: string;
  config: NbToastrConfig;
}

